import { useCallback } from 'react';
import { toast } from 'react-toastify';
import http from '@core/http';
import apiConfig from '@apiConfig';

export default function useDownload(downloadEndpoint: string) {
    const executeDownload = useCallback(
        (params: Record<string, unknown>) => {
            toast.info("Downloading...");

            http.downloadFileXHRFromUrl('GET', apiConfig.get(downloadEndpoint, params))
                .then(() => {
                    toast.success("Download was successful");
                })
                .catch(() => {
                    toast.error("Something went wrong");
                });
        },
        [downloadEndpoint]
    );

    return executeDownload;
}
